export default __webpack_public_path__ + "7af0ce5.png";